import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BrandWordmark } from "@/components/Brand";
import { LanguageToggle } from "@/components/LanguageToggle";
import { useLang } from "@/lib/i18n";

export const LegalLayout = ({ title, updated, sections, testId }) => {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-background">
      <header className="mx-auto flex max-w-3xl items-center justify-between px-6 py-5">
        <Link to="/login" className="inline-flex items-center" data-testid="legal-brand-link">
          <BrandWordmark className="text-base" markClassName="h-7 w-7" />
        </Link>
        <LanguageToggle />
      </header>
      <main data-testid={testId} className="mx-auto max-w-3xl px-6 pb-20">
        <Link to="/login" className="mb-6 inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors duration-150 hover:text-foreground">
          <ArrowLeft className="h-4 w-4" /> {t("back")}
        </Link>
        <h1 className="text-3xl font-semibold tracking-tight">{title}</h1>
        <p className="mt-2 text-xs text-muted-foreground">{updated}</p>
        <div className="mt-8 space-y-7">
          {sections.map((s) => (
            <section key={s.h}>
              <h2 className="text-base font-semibold">{s.h}</h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground/85">{s.p}</p>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
};
